var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeiaPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:0;}.b{clip-path:url(#a);}.c{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(544 296)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-544 -296)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(544 296)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M28.333,13.333H11.667a3.343,3.343,0,0,0-3.333,3.333V33.333a3.343,3.343,0,0,0,3.333,3.333H28.333a3.343,3.343,0,0,0,3.333-3.333V16.667A3.343,3.343,0,0,0,28.333,13.333ZM20,34.167h0A1.672,1.672,0,0,1,18.333,32.5v-.833h3.333V32.5A1.672,1.672,0,0,1,20,34.167ZM21.667,30H18.333c0-2.5-4.167-5-4.167-8.333a5.833,5.833,0,1,1,11.667,0C25.833,25,21.667,27.5,21.667,30ZM30,10.833H10a2.5,2.5,0,0,1,2.5-2.5h15a2.5,2.5,0,0,1,2.5,2.5Zm-1.667-5H11.667a2.5,2.5,0,0,1,2.5-2.5H25.833a2.5,2.5,0,0,1,2.5,2.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeiaPurple);
export default __webpack_public_path__ + "static/media/ideiaPurple.f2fede84c55e631b11bfdcb89eaaefb4.svg";
export { ForwardRef as ReactComponent };